import "./Home.css";
import { Button } from "../../components/primitives";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import homeAsset1 from "../../assets/home-asset-1.png";
import browseExample1 from "../../assets/browse-example-1.png.avif";
import chatExample1 from "../../assets/chat-example-1.png.avif";

// Public store listings for the Better Intentions mobile app (com.betterintentions.myapp).
const APP_STORE_URL = "https://apps.apple.com/app/id6763169189";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.betterintentions.myapp";

export default function Home() {
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState(null);

  const openPreview = (src, label) => setPreviewImage({ src, label });
  const closePreview = () => setPreviewImage(null);

  useEffect(() => {
    if (!previewImage) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") closePreview();
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [previewImage]);

  return (
    <main className="landingHome">
      <section className="landingHome__hero">
        <div className="landingHome__heroInner">
          <div className="landingHome__copy">
            <div className="landingHome__assetWrap" aria-hidden="true">
              <img src={homeAsset1} alt="" className="landingHome__assetImage" />
            </div>
            <h1 className="landingHome__headline">
              <span className="landingHome__better">Better</span>{" "}
              <span className="landingHome__focusWord">Connections.</span>
              <br />
              <span className="landingHome__better">Better</span>{" "}
              <span className="landingHome__focusWord">Conversations.</span>
              <br />
              <span className="landingHome__better">Better</span>{" "}
              <span className="landingHome__focusWord">Intentions.</span>
            </h1>
            <p className="landingHome__sub">
              A community built on respectful dialogue, and a willingness to meet people "where they are".
            </p>
            <Button
              variant="primary"
              size="lg"
              className="landingHome__cta"
              onClick={() => navigate("/active")}
            >
              Start Now
            </Button>

            <div className="landingHome__storeRow">
              <p className="landingHome__storeLabel">Prefer the app? Get it on your phone.</p>
              <div className="landingHome__storeButtons">
                <a
                  className="landingHome__storeBadge"
                  href={APP_STORE_URL}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Download Better Intentions on the App Store"
                >
                  <svg className="landingHome__storeIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M16.37 12.64c-.03-2.6 2.13-3.85 2.22-3.91-1.21-1.77-3.09-2.01-3.76-2.04-1.6-.16-3.12.94-3.93.94-.81 0-2.06-.92-3.39-.89-1.74.03-3.35 1.01-4.25 2.57-1.81 3.14-.46 7.79 1.3 10.34.86 1.25 1.89 2.65 3.23 2.6 1.3-.05 1.79-.84 3.36-.84 1.57 0 2.01.84 3.38.81 1.4-.02 2.28-1.27 3.13-2.52.99-1.45 1.39-2.85 1.42-2.92-.03-.01-2.72-1.04-2.71-4.14zM13.79 5c.71-.86 1.19-2.06 1.06-3.25-1.02.04-2.26.68-2.99 1.54-.66.76-1.23 1.98-1.08 3.15 1.14.09 2.3-.58 3.01-1.44z" />
                  </svg>
                  <span className="landingHome__storeText">
                    <span className="landingHome__storeSmall">Download on the</span>
                    <span className="landingHome__storeBig">App Store</span>
                  </span>
                </a>
                <a
                  className="landingHome__storeBadge"
                  href={PLAY_STORE_URL}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Get Better Intentions on Google Play"
                >
                  <svg className="landingHome__storeIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M3.6 2.3c-.3.3-.5.8-.5 1.4v16.6c0 .6.2 1.1.5 1.4l.1.1 9.3-9.3v-.2L3.7 2.2l-.1.1z" fill="#00d7fe" />
                    <path d="M16.1 15.6l-3.1-3.1v-.2l3.1-3.1.1.1 3.7 2.1c1.1.6 1.1 1.6 0 2.2l-3.7 2.1-.1-.1z" fill="#ffce00" />
                    <path d="M16.2 15.5L13 12.3l-9.4 9.4c.3.4.9.4 1.6 0l11-6.2" fill="#ff3a44" />
                    <path d="M16.2 9.1L5.2 2.9c-.6-.4-1.2-.3-1.6 0L13 12.3l3.2-3.2z" fill="#00f076" />
                  </svg>
                  <span className="landingHome__storeText">
                    <span className="landingHome__storeSmall">Get it on</span>
                    <span className="landingHome__storeBig">Google Play</span>
                  </span>
                </a>
              </div>
            </div>
          </div>

          <div className="landingHome__visual">
            <div className="landingHome__visualStack">
              <button
                type="button"
                className="landingHome__imageButton landingHome__browseButton"
                onClick={() => openPreview(browseExample1, "Browse example")}
                aria-label="Open browse example image"
              >
                <img src={browseExample1} alt="Browse example" className="landingHome__browseImage" />
              </button>
              <button
                type="button"
                className="landingHome__imageButton landingHome__chatButton"
                onClick={() => openPreview(chatExample1, "Chat example")}
                aria-label="Open chat example image"
              >
                <img src={chatExample1} alt="Chat example" className="landingHome__chatImage" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {previewImage && (
        <div
          className="landingHome__lightbox"
          role="dialog"
          aria-modal="true"
          aria-label={`${previewImage.label} preview`}
          onClick={closePreview}
        >
          <div className="landingHome__lightboxCard" onClick={(event) => event.stopPropagation()}>
            <button
              type="button"
              className="landingHome__lightboxClose"
              onClick={closePreview}
              aria-label="Close image preview"
            >
              Close
            </button>
            <img
              src={previewImage.src}
              alt={`${previewImage.label} enlarged`}
              className="landingHome__lightboxImage"
            />
          </div>
        </div>
      )}

      <footer className="landingHome__footer">
        <div className="landingHome__footerInner">
          <a className="landingHome__footerLink" href="/terms-of-service">Terms of Service</a>
          <span className="landingHome__footerSeparator" aria-hidden="true">•</span>
          <a className="landingHome__footerLink" href="/privacy-policy">Privacy Policy</a>
          <span className="landingHome__footerSeparator" aria-hidden="true">•</span>
          <a className="landingHome__footerLink" href="/privacy-choices">Your Privacy Choices</a>
          <span className="landingHome__footerSeparator" aria-hidden="true">•</span>
          <a className="landingHome__footerLink" href="/child-safety.html">Child Safety</a>
          <span className="landingHome__footerSeparator" aria-hidden="true">•</span>
          <a className="landingHome__footerLink" href="/support">Support</a>
          <span className="landingHome__footerSeparator" aria-hidden="true">•</span>
          <span className="landingHome__footerSocial">
          <a
            className="landingHome__socialLink"
            href="https://www.facebook.com/BetterIntentions"
            target="_blank"
            rel="noreferrer"
            aria-label="Better Intentions on Facebook"
            title="Facebook"
          >
            <svg className="landingHome__socialIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M14 8.25H16V5H13.5C10.86 5 9.25 6.58 9.25 9.34V11H7V14.5H9.25V21H13V14.5H15.55L16 11H13V9.65C13 8.72 13.32 8.25 14 8.25Z" />
            </svg>
          </a>
          <a
            className="landingHome__socialLink"
            href="https://www.instagram.com/joinbetterintentions"
            target="_blank"
            rel="noreferrer"
            aria-label="Better Intentions on Instagram"
            title="Instagram"
          >
            <svg className="landingHome__socialIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M7.75 2H16.25C19.42 2 22 4.58 22 7.75V16.25C22 19.42 19.42 22 16.25 22H7.75C4.58 22 2 19.42 2 16.25V7.75C2 4.58 4.58 2 7.75 2ZM7.75 4C5.68 4 4 5.68 4 7.75V16.25C4 18.32 5.68 20 7.75 20H16.25C18.32 20 20 18.32 20 16.25V7.75C20 5.68 18.32 4 16.25 4H7.75ZM12 7.25C14.62 7.25 16.75 9.38 16.75 12C16.75 14.62 14.62 16.75 12 16.75C9.38 16.75 7.25 14.62 7.25 12C7.25 9.38 9.38 7.25 12 7.25ZM12 9.25C10.48 9.25 9.25 10.48 9.25 12C9.25 13.52 10.48 14.75 12 14.75C13.52 14.75 14.75 13.52 14.75 12C14.75 10.48 13.52 9.25 12 9.25ZM17.05 6.7C17.74 6.7 18.3 7.26 18.3 7.95C18.3 8.64 17.74 9.2 17.05 9.2C16.36 9.2 15.8 8.64 15.8 7.95C15.8 7.26 16.36 6.7 17.05 6.7Z" />
            </svg>
          </a>
          </span>
        </div>
      </footer>
    </main>
  );
}
